// 2026 lineup. Order matches the on-site billing order shown on the
// poster. `sets` and `lateNight` come from the poster's annotations.

export const lineup2026 = [
  {
    id: "leftover-salmon",
    name: "Leftover Salmon",
    photo: "/artists/leftover-salmon.jpg",
    headliner: true,
    sets: 3,
    tribute: "Jerry Garcia Tribute Set",
    blurb:
      "Progressive bluegrass pioneers — 35+ years of jamgrass, with founding members Drew Emmitt and Vince Herman alongside Andy Thorn, Greg Garrison, Alwyn Robinson, and Jay Starling.",
  },
  {
    id: "infamous-stringdusters",
    name: "Infamous Stringdusters",
    photo: "/artists/infamous-stringdusters.jpg",
    headliner: true,
    sets: 2,
    blurb:
      "GRAMMY-winning progressive bluegrass quintet known for energetic live shows and improvisational fire.",
  },
  {
    id: "moontricks",
    name: "Moontricks",
    photo: "/artists/moontricks.jpg",
    blurb:
      "Electro-folk duo from British Columbia blending organic roots with electronic production — breakout hit “Home” cleared 10 million streams.",
  },
  {
    id: "brothers-comatose",
    name: "The Brothers Comatose",
    photo: "/artists/brothers-comatose.jpg",
    blurb:
      "West Coast roots band fusing old school string-band instrumentation with rock and roll exuberance. Latest album: Golden Grass.",
  },
  {
    id: "clay-street-unit",
    name: "Clay Street Unit",
    photo: "/artists/clay-street-unit.jpg",
    blurb:
      "Denver-based group mixing bluegrass and folk with amplified Americana — torchbearers of something both fresh and familiar.",
  },
  {
    id: "big-something",
    name: "Big Something",
    photo: "/artists/big-something.jpg",
    blurb:
      "Six-piece North Carolina rock band with seven studio albums, founders of The Big What? Festival.",
  },
  {
    id: "dom-flemons",
    name: "Dom Flemons & the Traveling Wildfires",
    photo: "/artists/dom-flemons.jpg",
    blurb:
      "Grammy-winning American Songster and Banjo Hall of Fame inductee, leading a supergroup across bluegrass, country, folk, blues, and Black string-band traditions.",
  },
  {
    id: "fretliners",
    name: "The Fretliners",
    photo: "/artists/fretliners.png",
    blurb:
      "Acoustic string band built around songwriting and harmony — swept Telluride Bluegrass and RockyGrass band competitions in 2023.",
  },
  {
    id: "magoo",
    name: "Magoo",
    photo: "/artists/magoo.jpg",
    lateNight: true,
    blurb:
      "Progressive bluegrass quartet from Denver. Debut album What a Life arrives February 2026, featuring Sam Bush.",
  },
  {
    id: "fireside-collective",
    name: "Fireside Collective",
    photo: "/artists/fireside-collective.jpg",
    blurb:
      "Newgrass-turned-jamband from Asheville — bluegrass, folk, rock, and funk in one hybrid sound since 2014.",
  },
  {
    id: "daniel-rodriguez",
    name: "Daniel Rodriguez",
    photo: "/artists/daniel-rodriguez.jpg",
    blurb:
      "Solo artist formerly of Elephant Revival. The Lumineers recorded his song “This Is Life” and brought him on their BRIGHTSIDE World Tour.",
  },
  {
    id: "sneezy",
    name: "Sneezy",
    photo: "/artists/sneezy.jpg",
    blurb:
      "Chicago funk-soul jamband blending neo-soul rhythms, hip-hop beats, and rock energy into immersive live shows.",
  },
  {
    id: "sqwerv",
    name: "Sqwerv",
    photo: "/artists/sqwerv.jpg",
    lateNight: true,
    blurb:
      "Denver indie-jamband running classic rock, psychedelic music, funk, and jam fusion through deep improvisation.",
  },
  {
    id: "silas-herman",
    name: "Silas Herman & the Tone Unit",
    photo: "/artists/silas-herman.jpg",
    blurb:
      "Progressive bluegrass project from Nederland, Colorado. Multi-instrumentalist who's shared stages with Del McCoury, Sam Bush, and Billy Strings.",
  },
  {
    id: "natalie-brooke",
    name: "Natalie Brooke",
    photo: "/artists/natalie-brooke.jpg",
    blurb:
      "Virtuoso funk/rock keys player from Baltimore — keys, synth, keytar, and vocals, described as a mash-up of Rick James and Rush.",
  },
  {
    id: "graham-good",
    name: "Graham Good & The Painters",
    photo: "/artists/graham-good.jpg",
    blurb:
      "Rock/folk/funk from Colorado — five-time Battle of the Bands winners, with Red Rocks, the Ogden, the Gothic, and the Bluebird in the rear-view.",
  },
  {
    id: "mighty-mystic",
    name: "Mighty Mystic",
    photo: "/artists/mighty-mystic.jpeg",
    blurb:
      "Reggae artist pioneering the HARD ROOTS blend of reggae with hip-hop and rock — known for international hit “Riding on the Clouds.”",
  },
];

export const previousLineups = [
  { year: 2025, poster: "/posters/lineup-2025.webp" },
  { year: 2024, poster: "/posters/lineup-2024.webp" },
  { year: 2023, poster: "/posters/lineup-2023.jpg" },
  { year: 2022, poster: "/posters/lineup-2022.jpg" },
];
